import React, {Component} from 'react'

class MapsDrawingTools extends Component {
    constructor(props) {
        super(props)
        this.marker = null
        
        this._handleDrawPolygon = this._handleDrawPolygon.bind(this)
        this._handleDrawPoint = this._handleDrawPoint.bind(this)
        this._handleDrawLine = this._handleDrawLine.bind(this)
        this._handleSave = this._handleSave.bind(this)
        this._handleXY = this._handleXY.bind(this)

        this.activePolygon = '/Images/activated_polygon@3x.png'
        this.activePolyline = '/Images/activated_line_4@3x.png'
        this.activePoint = '/Images/activated_point@3x.png'
        this.deactivePolygon = '/Images/polygon@3x.png'
        this.deactivePolyline = '/Images/line_4@3x.png'
        this.deactivePoint = '/Images/point@3x.png'
        this.primaryDone = '/Images/primary_done@3x.png'
        this.showMarker = '/Images/show_marker_2@3x.png'
        this.hideMarker = '/Images/hide_marker_2@3x.png'
        this.saveBtn    = '/Images/save_button_2@3x.png'
    }

    componentWillUnmount(){
        window.drawingManager.setMap(null)
    }

    _handleDrawPolygon() {
        const { setSelectedShape } = this.props
        setSelectedShape(null)
        if (document.getElementById("drawPolygon").src === window.location.origin+this.activePolygon) {    
            document.getElementById("drawPolygon").src = this.primaryDone
            document.getElementById("drawLine").src = this.deactivePolyline
            document.getElementById("drawPoint").src = this.deactivePoint
            window.drawingManager.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
            window.drawingManager.setMap(window.mapRef)
        } else {
            window.drawingManager.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
            window.drawingManager.setMap(null)
            document.getElementById("drawPolygon").src = this.activePolygon
            document.getElementById("drawLine").src = this.activePolyline
            document.getElementById("drawPoint").src = this.activePoint
            window.google.maps.event.clearListeners(window.mapRef, 'click');
        }
    }
    
    _handleDrawPoint() {
        const { setSelectedShape } = this.props
        setSelectedShape(null)
        if (document.getElementById("drawPoint").src === window.location.origin+this.activePoint) {
            document.getElementById("drawPoint").src = this.primaryDone
            document.getElementById("drawPolygon").src = this.deactivePolygon
            document.getElementById("drawLine").src = this.deactivePolyline

            window.drawingManager.setDrawingMode(window.google.maps.drawing.OverlayType.MARKER);
            window.drawingManager.setMap(window.mapRef)
        } else {
            window.drawingManager.setDrawingMode(window.google.maps.drawing.OverlayType.MARKER);
            window.drawingManager.setMap(null)
            document.getElementById("drawPoint").src = this.activePoint
            document.getElementById("drawPolygon").src = this.activatePolygon
            document.getElementById("drawLine").src = this.activePolyline
        }
    }

    _handleDrawLine() {
        const { setSelectedShape } = this.props
        setSelectedShape(null)
        if (document.getElementById("drawLine").src === window.location.origin+this.activePolyline) {
            document.getElementById("drawLine").src = this.primaryDone
            document.getElementById("drawPolygon").src = this.deactivePolygon
            document.getElementById("drawPoint").src = this.deactivePoint

            window.drawingManager.setDrawingMode(window.google.maps.drawing.OverlayType.POLYLINE);
            window.drawingManager.setMap(window.mapRef)
        } else {
            window.drawingManager.setDrawingMode(window.google.maps.drawing.OverlayType.POLYLINE);
            window.drawingManager.setMap(null)
            document.getElementById("drawLine").src = this.activePolyline
            document.getElementById("drawPolygon").src = this.activePolygon
            document.getElementById("drawPoint").src = this.activePoint
        }
    }

    _handleSave(){
        const{ setSaved } = this.props
        window.drawingManager.setMap(null)
        setSaved(true)
    }

    _handleXY(){
        const { currentPlan, setCurrentPlan } = this.props
        if ( document.getElementById("drawXY").src === window.location.origin+this.hideMarker ) {
            window.google.maps.event.addListener(window.mapRef, 'click', function(event) {
                currentPlan.markerCoord = {
                    lat:event.latLng.lat(),
                    lng:event.latLng.lng()
                }
                setCurrentPlan(currentPlan)
                window.google.maps.event.clearListeners(window.mapRef,'click')
            });
            document.getElementById("drawXY").src = this.showMarker
        }
        else if ( document.getElementById("drawXY").src === window.location.origin+this.showMarker ){
            document.getElementById("drawXY").src = this.hideMarker
            window.google.maps.event.clearListeners(window.mapRef,'click')
            currentPlan.markerCoord = null
            setCurrentPlan(currentPlan)
        }
    }

    render() {
        const { currentPlan } = this.props
        var toggleXY = null
        if( currentPlan !== null && currentPlan.markerCoord !== null && currentPlan.markerCoord !== '' ){
            toggleXY = <span className = "icon has-text-primary"><img id = "drawXY" src={this.showMarker} alt="XY"/></span >
        }
        else{
            toggleXY = <span className = "icon has-text-primary"><img id = "drawXY" src={this.hideMarker} alt="XY"/></span >
        }
        return ( 
            <div className = "MapsDrawingTools" >
                <div className = "button is-black is-circle is-shadow" onClick = {this._handleXY} >
                    {toggleXY}
                </div> 
                <div className = "button is-black is-circle is-shadow" onClick = {this._handleDrawPolygon} >
                    <span className = "icon has-text-primary"><img id = "drawPolygon" src={this.activePolygon} alt="Polygon"/></span >
                </div> 
                <div className = "button is-black is-circle is-shadow" onClick = {this._handleDrawLine} >
                    <span className = "icon has-text-primary"><img id = "drawLine" src={this.activePolyline} alt="Line" /></span >
                </div>
                <div className = "button is-black is-circle is-shadow" onClick = {this._handleDrawPoint} >
                    <span className = "icon has-text-primary"><img id = "drawPoint" src={this.activePoint} alt="Point"/></span >
                </div> 
                <div className = "button is-black is-circle is-shadow" onClick = {this._handleSave} >
                    <span className = "icon has-text-primary"><img id = "save" src={this.saveBtn} alt="Save" /></span >
                </div> 
            </div>
        )
    }
}

export default MapsDrawingTools


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsDrawingTools.js